export default "__VITE_ASSET__9ea951dd__"